export const breakpoints = {
    PHONE: '375',
    TABLET: '768',
    BIG_TABLET: '1024',
    DESKTOP: '1440',
}